<script setup>
import { Link, usePage } from '@inertiajs/vue3';
const page = usePage()
const company = page.props.shared_data.company
const primaryPhone = company['phone'].split(",")
</script>
<template>
    <div class="relative flex justify-end z-50">
        <a :href="`tel:`+primaryPhone[0]" class="flex items-center justify-center bg-primary sm:px-4 px-2 py-[5px] bottom-8 sm:left-8 left-6 rounded-full text-center text-gray-700 sm:text-[15px] text-[13px] font-semibold border border-primary uppercase tracking-wider cursor-pointer hover:bg-[#1565C0] hover:border-[#1565C0] transition duration-300 fixed">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                class="sm:w-6 w-4 sm:h-6 h-4 mr-2">
                <path fill-rule="evenodd" d="M2 3.5A1.5 1.5 0 0 1 3.5 2h1.148a1.5 1.5 0 0 1 1.465 1.175l.716 3.223a1.5 1.5 0 0 1-1.052 1.767l-.933.267c-.41.117-.643.555-.48.95a11.542 11.542 0 0 0 6.254 6.254c.395.163.833-.07.95-.48l.267-.933a1.5 1.5 0 0 1 1.767-1.052l3.223.716A1.5 1.5 0 0 1 18 15.352V16.5a1.5 1.5 0 0 1-1.5 1.5H15c-1.149 0-2.263-.15-3.326-.43A13.022 13.022 0 0 1 2.43 8.326 13.019 13.019 0 0 1 2 5V3.5Z" clip-rule="evenodd" />
            </svg> {{$t('common.consultation')}} </a>
    </div>
</template>
<style scoped></style>



